module.exports = __webpack_public_path__ + "img/collectionImgs.c2bd1ae0.svg";